var _path, _path2, _path3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSadFaceBorder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 271,
    height: 271,
    viewBox: "0 0 271 271",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6459 203.596C94.3407 203.596 93.0356 202.632 92.383 201.024C91.4857 198.667 92.2198 195.881 94.0145 194.595C94.4223 194.381 105.353 187.095 120.934 183.452C141.735 178.523 160.824 182.488 176.241 194.81C177.954 196.203 178.525 199.096 177.465 201.346C176.404 203.596 174.202 204.239 172.489 202.953C138.799 175.952 97.6853 202.846 97.2774 203.06C96.7336 203.417 96.1898 203.596 95.6459 203.596Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.8942 87.3029C93.2328 83.3869 104.76 88.6082 108.681 98.8136C112.603 109.138 107.493 120.767 97.1543 124.683C86.8158 128.599 75.289 123.496 71.3675 113.172C67.3271 102.848 72.5557 91.3376 82.8942 87.3029Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M169.894 87.3029C180.233 83.3869 191.76 88.6082 195.681 98.8136C199.603 109.138 194.493 120.767 184.154 124.683C173.816 128.599 162.289 123.496 158.367 113.172C154.327 102.848 159.556 91.3376 169.894 87.3029Z",
    fill: "black"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 135.5,
    cy: 135.5,
    r: 128,
    stroke: "black",
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSadFaceBorder);
export default __webpack_public_path__ + "static/media/sad-face-border.5a79d1a554136713c07ca5291501812b.svg";
export { ForwardRef as ReactComponent };